import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import moment from "moment";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";

import {
  title,
  history,
  validateProfileFields,
  displayErrorContext,
  selectProps,
  datePickerProps,
  textareaProps,
} from "utils";
import { Can } from "constants/abilityContext";
import { icons } from "constants/icons";
import {
  ANALYSIS_TYPE_FINANCE,
  ANALYSIS_TYPE_TECHNICAL,
  ANALYSIS_TYPE_CHANCE,
  DEFAULT_ANALYSIS_FINANCE_FORM,
  DEFAULT_ANALYSIS_TECHNICAL_FORM,
  DEFAULT_ANALYSIS_CHANCE_FORM,
  ANALYSIS_TYPES_LIST,
  ANALYSIS_SCALE_HIGH,
  ANALYSIS_SCALE_MODERATE,
  ANALYSIS_SCALE_LABELS,
  USER_RANK_ADMIN,
} from "constants/dbValues";

import { Header, InvitationsTable, NewClientModal } from "components";
import {
  Divider,
  Button,
  notification,
  Spin,
  Icon,
  Input,
  InputNumber,
  Select,
  Checkbox,
  DatePicker,
  Modal,
} from "antd";
import { Row, Col, Card } from "antd";

import {
  analyzeService,
  submissionService,
  selectService,
  userService,
  clientService,
} from "services";
import { connect } from "react-redux";

import { computeAnalysisScore } from "utils";

const ANALYSIS_TITLE = {
  finance: "Analyse de risque financier",
  technical: "Analyse de risque technique",
  chance: "Analyse de chance",
};

const UNSAVED_CHANGES_MESSAGE =
  "Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?";

class SubmissionPage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    this.state = {
      submission: {
        __type: "Submission",
        id: id || "Sera généré après la création",
        submission_state_id: 2,
      },
      saving: false,
      errors: {},
      edited: false,
      selects: {},

      editModal: props.edit,
      newInvitationModal: false,
      analysisModal: false,
      newClientModalDisplayed: false,

      financeAnalysis: {},
      technicalAnalysis: {},
      chanceAnalysis: {},
      financeEdited: false,
      technicalEdited: false,
      chanceEdited: false,
      financeFormErrors: {},
      chanceFormErrors: {},
      technicalFormErrors: {},
      financeFormUploading: false,
      chanceFormUploading: false,
      technicalFormUploading: false,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderFieldsForm = this.renderFieldsForm.bind(this);
    this.renderInformations = this.renderInformations.bind(this);
    this.renderAnalysis = this.renderAnalysis.bind(this);
    this.renderAnalysisModalContent = this.renderAnalysisModalContent.bind(this);
    this.renderInvitations = this.renderInvitations.bind(this);
    this.renderNewInvitationsModalContent = this.renderNewInvitationsModalContent.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.openNewClientModal = this.openNewClientModal.bind(this);
    this.closeNewClientModal = this.closeNewClientModal.bind(this);
    this.handleClientCreated = this.handleClientCreated.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchData() {
    if (this.props.create) return this.fetchSelects();

    const { submission } = this.state;
    submissionService
      .get(submission.id)
      .then((result) => {
        if (!this._mounted) return;
        this.setState({ submission: { ...submission, ...result } });
        this.fetchSelects();
        this.fetchAnalysis(submission.id);
      })
      .catch((e) => {
        if (!this._mounted) return;
        if (this.props.modalOnly) return this.props.onModalClose();
        history.push("/submissions");
      });
  }

  fetchAnalysis(submission_id) {
    analyzeService.list({ submission_id }).then((result) => {
      if (!this._mounted) return;
      const financeAnalysis = result.find((ana) => ana.analyze_type_id === ANALYSIS_TYPE_FINANCE);
      const technicalAnalysis = result.find(
        (ana) => ana.analyze_type_id === ANALYSIS_TYPE_TECHNICAL,
      );
      const chanceAnalysis = result.find((ana) => ana.analyze_type_id === ANALYSIS_TYPE_CHANCE);
      // SI PAS DE REPONSE EN DB ON MET DES VALUE PAR DEFAUT DANS LES FORM D'ANALYZE
      if (result.length == 0) {
        this.setState((state) => ({
          financeAnalysisForm: DEFAULT_ANALYSIS_FINANCE_FORM,
          technicalAnalysisForm: DEFAULT_ANALYSIS_TECHNICAL_FORM,
          chanceAnalysisForm: DEFAULT_ANALYSIS_CHANCE_FORM,
        }));
      } else {
        this.setState((state) => ({
          financeAnalysis: {
            ...financeAnalysis,
            value: Number(financeAnalysis?.value || 0) / 100,
            answers: JSON.parse(financeAnalysis?.answers || null),
          },
          technicalAnalysis: {
            ...technicalAnalysis,
            value: Number(technicalAnalysis?.value || 0) / 100,
            answers: JSON.parse(technicalAnalysis?.answers || null),
          },
          chanceAnalysis: {
            ...chanceAnalysis,
            value: Number(chanceAnalysis?.value || 0) / 100,
            answers: JSON.parse(chanceAnalysis?.answers || null),
          },
        }));
      }
    });
  }

  async fetchSelects() {
    const selects = await selectService.listForPage("submission");
    const users = await userService.list();
    const clients = await clientService.list();
    const questions = await submissionService.listQuestions();

    if (!this._mounted) return;

    this.setState({
      selects: {
        ...selects,
        User: users,
        Client: clients,
        questions: questions.map((q) => {
          // console.log('COUCOU options ', q.options)
          return q.options ? { ...q, options: JSON.parse(q.options) } : q;
        }),
      },
    });
  }

  handleChange(value, key, callback = () => {}) {
    this.setState(
      {
        submission: {
          ...this.state.submission,
          [key]: value,
        },
        edited: true,
      },
      callback,
    );
  }

  handleSubmit(invitationsOnly = false, callback = () => {}) {
    if (this.state.saving) return;
    if (!this.validateFields()) return;

    let submission = { ...this.state.submission };
    const { edit, create } = this.props;

    const func = submissionService[create ? "create" : "update"];
    if (create) {
      // if (!submission.user_id)
      //     submission.user_id = this.props.userId;
      delete submission.id;
    }

    if (invitationsOnly && !create) {
      submission = {
        id: submission.id,
        invitations_attributes: submission.invitations,
      };
    }

    const errorNotification = (e) => {
      this.setState({ saving: false });
      notification.open({
        message: "Une erreur s'est produite",
        description: "Veuillez réessayer ou contacter un administrateur.",
        placement: "bottomRight",
      });
    };

    this.setState({ saving: true }, () => {
      func(submission)
        .then((n) => {
          notification.open({
            message: "Enregistrement effectué",
            description: "Vos changements ont été enregistrés avec succès.",
            placement: "bottomRight",
          });

          this.setState({
            submission: { ...this.state.submission, ...n },
            edited: false,
            saving: false,
            editModal: false,
          });

          if (this.props.modalOnly) {
            this.props.onModalClose(n);
            return callback();
          }

          history.replace(`/submissions/${n.id}`);
          callback();
        })
        .then(() => {
          if (this.props.modalOnly) return;
          if (sessionStorage.getItem("gb")) {
            history.push(`/dashboardsoumissions${this.props.location?.search || ""}`);
          }
        })
        .catch((e) => errorNotification(e));
    });
  }

  handleAnalysisSubmit = () => {
    for (let i = 0; i < ANALYSIS_TYPES_LIST.length; ++i) {
      const analysisTypeObj = ANALYSIS_TYPES_LIST[i];
      const analysisType = analysisTypeObj.key;
      const answers = this.state[analysisType + "AnalysisForm"]?.answers;
      const value = this.state[analysisType + "AnalysisForm"]?.value;
      if (!answers || !this.validateAnswers(answers, analysisType)) continue;
      const analysis = { ...this.state[analysisType + "Analysis"] };
      analysis.value = value * 100;
      analysis.answers = JSON.stringify(answers);

      // console.log('COUCOU submitting analysis', analysis)

      const create = !analysis.id;
      const func = analyzeService[!create ? "update" : "create"];
      if (create) {
        analysis.submission_id = this.state.submission.id;
        analysis.analyze_type_id = analysisTypeObj.value;
      }

      const errorNotification = (e) => {
        this.setState({ [analysisType + "FormUploading"]: false });
        notification.open({
          message: "Une erreur s'est produite",
          description: "Veuillez réessayer ou contacter un administrateur.",
          placement: "bottomRight",
        });
      };

      this.setState({ [analysisType + "FormUploading"]: true }, () => {
        func(analysis)
          .then((n) => {
            notification.open({
              message: "Enregistrement effectué",
              description: "Vos changements ont été enregistrés avec succès.",
              placement: "bottomRight",
            });
            delete n.value;
            delete n.answers;
            this.setState((state) => ({
              [analysisType + "Analysis"]: {
                ...state[analysisType + "Analysis"],
                ...n,
                answers,
                value,
              },
              [analysisType + "Edited"]: false,
              [analysisType + "FormUploading"]: false,
              [analysisType + "Errors"]: null,
              analysisModal: false,
            }));
          })
          .catch((e) => errorNotification(e));
      });
    }
  };

  /**
   * Met à jour les valeurs de formulaire
   * @param analysisType: "finance" | "technical" | "chance"
   */
  handleAnalysisAnswer = (analysisType, value, key) => {
    this.setState((state) => {
      const answers = {
        ...state[analysisType + "Analysis"]?.answers,
        ...state[analysisType + "AnalysisForm"]?.answers,
        [key]: value,
      };
      return {
        [analysisType + "AnalysisForm"]: {
          ...state[analysisType + "AnalysisForm"],
          answers,
          value: computeAnalysisScore(
            answers,
            state.selects.questions,
            ANALYSIS_TYPES_LIST.find((anaType) => anaType.key === analysisType).multi,
          ),
        },
        [analysisType + "Edited"]: true,
      };
    });
  };

  renderFieldsForm() {
    const { submission, selects } = this.state;

    const renderByType = (field) => {
      let props = {
        value: submission[field.key],
        onChange: (val) => this.handleChange(val, field.key),
        ...field.props,
      };

      switch (field.type) {
        case "number":
          return <InputNumber {...props} />;
        case "select":
          let options = selects[field.options.model] || [];
          props = {
            ...props,
            ...selectProps(),
          };

          if (typeof props.value === "undefined") delete props.value;

          if (field.options.restrictTo) options = options.filter(field.options.restrictTo);

          if (field.key === "client_id") {
            props.dropdownRender = (menu) => (
              <div>
                {menu}
                <Divider style={{ margin: "4px 0" }} />
                <div
                  className="select-dropdown-action"
                  style={{ padding: "8px", cursor: "pointer" }}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={this.openNewClientModal}
                >
                  <Icon type="plus" /> Nouveau client
                </div>
              </div>
            );
          }

          return (
            <Select {...props}>
              {options.map((option) => (
                <Select.Option key={option.id} value={option.id}>
                  {field.options.label(option)}
                </Select.Option>
              ))}
            </Select>
          );
        case "date":
          props = {
            ...props,
            ...datePickerProps(props.showTime || false),
            value: submission[field.key] ? moment(submission[field.key]) : null,
          };

          return <DatePicker {...props} />;
        case "checkbox":
          props = {
            ...props,
            checked: submission[field.key],
            onChange: (e) => this.handleChange(e.target.checked, field.key),
          };

          delete props.value;

          return <Checkbox {...props} />;
        case "textarea":
          props = {
            ...props,
            ...textareaProps(),
            onChange: (e) => this.handleChange(e.target.value, field.key),
          };

          return <Input.TextArea {...props} />;
        default:
          props = {
            ...props,
            onChange: (e) => this.handleChange(e.target.value, field.key),
          };

          return <Input {...props} />;
      }
    };

    const wrap = (field, i) => (
      <div key={i} className={"ctn " + field.type + " " + field.key}>
        <label>
          {field.label}
          {field.type !== "checkbox" && " :"}
        </label>
        <span className={this.state.errors && this.state.errors[field.key] ? "error-wrap" : ""}>
          {renderByType(field)}
        </span>
      </div>
    );

    return (
      <>
        <div className="first-block">{FIELDS.filter((f) => f.block === "first").map(wrap)}</div>

        <div className="main-block">
          <Divider />
          {FIELDS.filter((f) => !f.block || f.block === "main").map(wrap)}
        </div>

        <div className="side-block">
          <Divider />
          {FIELDS.filter((f) => f.block === "side").map(wrap)}
        </div>

        <div className="supplement-block">
          <Divider />
          {FIELDS.filter((f) => f.block === "supplement").map(wrap)}
        </div>

        {displayErrorContext(this.state.errors)}

        <div className="buttons">
          <Button
            type="link"
            onClick={() => (this.props.modalOnly ? this.closeEditModal() : history.goBack())}
          >
            Annuler
          </Button>
          <Button
            type="primary"
            disabled={!this.state.edited || this.state.saving}
            onClick={() => this.handleSubmit()}
          >
            {this.props.create ? "Créer la soumission" : "Enregistrer les changements"}
          </Button>
        </div>

        <Prompt when={this.state.edited} message={UNSAVED_CHANGES_MESSAGE} />
      </>
    );
  }

  renderAnalysisForm(analysisType) {
    // console.log('coucou', analysisType)
    const {
      [analysisType + "Analysis"]: { answers: savedAnswers },
      selects: { questions },
    } = this.state;
    const answers = {
      ...savedAnswers,
      ...this.state[analysisType + "AnalysisForm"]?.answers,
    };

    // console.log('COUCOU answers', analysisType, answers)

    const edited = ANALYSIS_TYPES_LIST.some((ana) => !!this.state[ana.key + "Edited"]); // au moins une des analyses est éditée
    const errors = this.state[analysisType + "FormErrors"];

    const renderByType = (field) => {
      const value = answers && answers[field.key];
      // console.log('COUCOU field[' + field.key + ']', value)
      let props = {
        value,
        onChange: (val) => this.handleAnalysisAnswer(analysisType, val, field.key),
        ...field.props,
        required: true,
      };

      switch (field.type) {
        case "number":
          return <InputNumber {...props} />;
        case "select":
          const options = field.options;
          props = {
            ...props,
            ...selectProps(),
          };

          return (
            <Select {...props}>
              {options.map((option, i) => (
                <Select.Option key={i} value={i}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          );
        default:
          return <p>Une erreure est survenue</p>;
      }
    };
    const wrap = (field, i) => (
      <div key={i} className={"ctn " + field.type + " " + field.key}>
        <label>{field.label} :</label>
        <span className={errors && errors[field.key] ? "error-wrap" : ""}>
          {renderByType(field)}
        </span>
      </div>
    );

    const wizard = ["finance", "technical", "chance"]; // ordre des formulaires pour naviguer entre les étapes

    const nextStep =
      wizard[(wizard.findIndex((s) => s === this.state.analysisModal) + 1) % wizard.length];

    return (
      <>
        {React.Children.toArray(
          questions
            .filter(
              (q) =>
                q.analyze_type_id ===
                ANALYSIS_TYPES_LIST.find((ana) => ana.key === analysisType).value,
            )
            .sort((a, b) => a.order - b.order)
            .map((q) =>
              wrap(
                {
                  key: q.id.toString(),
                  type: q.options ? "select" : "number",
                  ...q,
                },
                q.id,
              ),
            ),
        )}
        {displayErrorContext(errors)}

        <div className="buttons">
          <Button type="primary" onClick={() => this.toggleModal("analysisModal", nextStep)}>
            Suivant <Icon type="double-right" />
          </Button>
        </div>
        <div className="buttons">
          <Button
            type="link"
            onClick={() =>
              this.setState({
                analysisModal: false,
                [analysisType + "AnalysisForm"]: null,
                [analysisType + "Edited"]: false,
                [analysisType + "FormErrors"]: null,
              })
            }
          >
            Annuler
          </Button>
          <Button
            type="primary"
            disabled={!edited}
            onClick={() => this.handleAnalysisSubmit(analysisType)}
          >
            Enregistrer l'analyse
          </Button>
        </div>

        <Prompt when={edited} message={UNSAVED_CHANGES_MESSAGE} />
      </>
    );
  }

  renderInformations() {
    const { submission } = this.state;

    return (
      <>
        <ul className="tags">
          <li>
            <Link to={`/clients/${submission.client_id}`}>
              <Icon type={icons.client} />
              {submission.client?.name}
            </Link>
          </li>
          <li className="alt">
            <Icon type="fork" />
            {submission.submission_state?.label}
          </li>
          <li className="alt">
            <Icon type="tag" />
            {submission.project_type?.label}
          </li>
          <li className="alt">
            <Icon type="pushpin" />
            {submission.region?.label}
          </li>
        </ul>

        <div className="informations-wrap">
          <p>
            <label>Estimateur :</label>
            <b>{submission.user ? `${submission.user.name} ${submission.user.surname}` : ""}</b>
          </p>

          <p>
            <label>Responsable client :</label>
            <b>{submission.client_manager}</b>
          </p>

          <p>
            <label>Montant déposé :</label>
            <b>{submission.ammount}</b>
          </p>

          <p>
            <label>Caution / Assurance :</label>
            <b>{submission.caution ? "Oui" : "Non"}</b>
          </p>

          <p>
            <label>Date de visite :</label>
            <b>
              {submission.date_visite
                ? moment(submission.date_visite).format("DD-MM-YYYY HH:mm")
                : ""}
            </b>
          </p>

          <p>
            <label>Date de dépot :</label>
            <b>
              {submission.date_depot
                ? moment(submission.date_depot).format("DD-MM-YYYY HH:mm")
                : ""}
            </b>
          </p>

          <p className="notes">
            <label>Notes :</label>
            <b>{submission.note}</b>
          </p>
        </div>
      </>
    );
  }

  getAnalysisScore(analysisType) {
    return this.state[analysisType + "AnalysisForm"]
      ? this.state[analysisType + "AnalysisForm"].value
      : this.state[analysisType + "Analysis"].value;
  }

  getRiskScore() {
    const financeScore = this.getAnalysisScore("finance");
    const technicalScore = this.getAnalysisScore("technical");

    if (financeScore != null && technicalScore != null) {
      return (financeScore + technicalScore) * 0.5;
    }
  }

  renderAnalysis() {
    // TODO : Modal avec les analyses
    // TODO : Display des scores
    function getStatus(score, isChance = false) {
      try {
        if (score > ANALYSIS_SCALE_HIGH) return !isChance ? "danger" : "success";
        if (score > ANALYSIS_SCALE_MODERATE) return "primary";
        if (score > 0) return !isChance ? "success" : "danger";
      } catch {}
      return "default";
    }

    const riskScore = parseInt(this.getRiskScore());
    const chanceScore = parseInt(this.getAnalysisScore("chance"));

    return (
      <>
        <div className="analysis-wrap">
          <div className="analysis-result">
            <Row gutter={6}>
              <Col span={12}>
                <Card title="Risques" className={getStatus(riskScore)}>
                  {riskScore}%
                </Card>
              </Col>
              <Col span={12}>
                <Card title="Chance" className={getStatus(chanceScore, true)}>
                  {chanceScore}%
                </Card>
              </Col>
            </Row>
          </div>
          <h4>Analyses réalisées :</h4>
          {React.Children.toArray(
            ANALYSIS_TYPES_LIST.map((anaType) => {
              const analysisScore = this.getAnalysisScore(anaType.key);
              const hasAnswers = Object.values({
                ...this.state[anaType.key + "Analysis"]?.answers,
                ...this.state[anaType.key + "AnalysisForm"]?.answers,
              }).some((a) => a != null);
              return (
                <Button
                  type={
                    !hasAnswers
                      ? "default"
                      : getStatus(analysisScore, anaType.value === ANALYSIS_TYPE_CHANCE)
                  }
                  onClick={() => this.toggleModal("analysisModal", anaType.key)}
                >
                  {anaType.label} : {parseInt(analysisScore)}%
                </Button>
              );
            }),
          )}
        </div>
      </>
    );
  }

  renderInvitations() {
    const { submission } = this.state;

    const updateInvitations = (invitations, callback) => {
      this.handleChange(invitations, "invitations", () => {
        this.handleSubmit(true, callback);
      });
    };

    return (
      <>
        <div className="invitations-wrap">
          <InvitationsTable
            invitations={submission.invitations}
            submission={submission}
            onUpdate={updateInvitations}
          />
        </div>
      </>
    );
  }

  renderAnalysisModalContent() {}

  renderNewInvitationsModalContent() {
    const { submission, selects } = this.state;
    const submitNewInvitations = (newInvitations) => {
      newInvitations = newInvitations.map((invitation) => ({
        ...invitation,
        date_created: moment(),
        submission_id: submission.id,
      }));

      this.handleChange(
        [...(submission.invitations || []), ...newInvitations],
        "invitations",
        () => {
          this.handleSubmit(true);
          this.toggleModal("newInvitationModal");
        },
      );
    };

    return (
      <InvitationsTable.NewModal
        submission={submission}
        selects={selects}
        onCreate={submitNewInvitations}
        closeModal={() => this.toggleModal("newInvitationModal")}
      />
    );
  }

  validateFields() {
    const { errors, hasError } = validateProfileFields(
      this.state.submission,
      FIELDS.filter((f) => f.required).map((f) => f.key),
    );

    this.setState({ errors });
    return !hasError;
  }

  validateAnswers(answers, analysisType) {
    const { errors, hasError } = validateProfileFields(
      answers,
      this.state.selects.questions
        .filter(
          (q) =>
            q.analyze_type_id ===
            ANALYSIS_TYPES_LIST.find((anaType) => anaType.key === analysisType),
        )
        .map((q) => q.id),
    );

    this.setState({ [analysisType + "FormErrors"]: errors });
    return !hasError;
  }

  closeEditModal() {
    if (this.state.edited && !window.confirm(UNSAVED_CHANGES_MESSAGE)) return;
    this.props.onModalClose();
  }

  toggleModal(type, key) {
    this.setState({ [type]: key && key !== this.state[type] ? key : !this.state[type] }, () => {
      if (type === "editModal") {
        history.push(`/submissions/${this.state.submission.id}${this.state[type] ? "/edit" : ""}`);
      }
    });
  }

  openNewClientModal() {
    this.setState({ newClientModalDisplayed: true });
  }

  closeNewClientModal() {
    this.setState({ newClientModalDisplayed: false });
  }

  handleClientCreated(created) {
    this.setState((state) => ({
      selects: {
        ...state.selects,
        Client: [...(state.selects.Client || []), created],
      },
      submission: { ...state.submission, client_id: created.id },
      edited: true,
      newClientModalDisplayed: false,
    }));
  }

  render() {
    const { submission } = this.state;

    if (this.props.modalOnly) {
      return (
        <>
          <Modal
            className="form-modal submission-edit-modal"
            visible={this.state.editModal}
            title={null}
            footer={null}
            onCancel={() => this.closeEditModal()}
          >
            <h3>Édition des informations</h3>
            {this.renderFieldsForm()}
          </Modal>

          <NewClientModal
            visible={this.state.newClientModalDisplayed}
            onCancel={this.closeNewClientModal}
            onCreated={this.handleClientCreated}
          />
        </>
      );
    }

    const { errors, saving } = this.state;
    const { edit, create } = this.props;

    let mode = "read",
      pageTitle = "Détails d'une soumission",
      header = `Soumission #${submission.num || submission.id}`,
      bread = [{ to: "/submissions", text: "Liste des soumissions" }, { text: submission.id }];

    if (create) {
      mode = "create";
      pageTitle = "Création d'une soumission";
      header = "Nouvelle soumission";
      bread = [{ to: "/submissions", text: "Liste des soumissions" }, { text: "Création" }];
    }

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <div className={`submission-page main-content profile-content ${mode}`}>
          <Can do={mode} on={submission}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={saving}
            >
              <div className={"profile-main-content " + mode}>
                {create ? (
                  <>
                    <div className="infos">
                      <h3>Configurations initiales de la soumission</h3>
                      {this.renderFieldsForm()}
                    </div>
                    <NewClientModal
                      visible={this.state.newClientModalDisplayed}
                      onCancel={this.closeNewClientModal}
                      onCreated={this.handleClientCreated}
                    />
                  </>
                ) : (
                  <>
                    <div className="infos">
                      <header>
                        <h3>{submission.title || ""}</h3>
                        <Button type="primary" onClick={() => this.toggleModal("editModal")}>
                          <Icon type="edit" />
                          Éditer
                        </Button>
                      </header>
                      {this.renderInformations()}
                    </div>

                    <div className="analysis">
                      <header>
                        <h3>Analyse</h3>
                      </header>
                      {this.renderAnalysis()}

                      <Modal
                        className="form-modal submission-edit-modal"
                        visible={!!this.state.analysisModal}
                        title={null}
                        footer={null}
                        onCancel={() => this.toggleModal("analysisModal")}
                      >
                        <h3>{ANALYSIS_TITLE[this.state.analysisModal]}</h3>
                        {this.state.analysisModal &&
                          this.renderAnalysisForm(this.state.analysisModal)}
                        {this.renderAnalysisModalContent()}
                      </Modal>
                    </div>

                    <div className="invitations">
                      <header>
                        <h3>Invitation</h3>
                        <Button
                          type="primary"
                          onClick={() => this.toggleModal("newInvitationModal")}
                        >
                          <Icon type="plus" />
                          Nouvelle invitation
                        </Button>
                      </header>
                      {this.renderInvitations()}

                      <Modal
                        className="form-modal submission-new-invitation-modal"
                        visible={this.state.newInvitationModal}
                        title={null}
                        footer={null}
                        onCancel={() => this.toggleModal("newInvitationModal")}
                      >
                        <h3>Nouvelle invitation</h3>
                        {this.renderNewInvitationsModalContent()}
                      </Modal>
                    </div>

                    <Modal
                      className="form-modal submission-edit-modal"
                      visible={this.state.editModal}
                      title={null}
                      footer={null}
                      onCancel={() => this.toggleModal("editModal")}
                    >
                      <h3>Édition des informations</h3>
                      {this.renderFieldsForm()}
                    </Modal>

                    <NewClientModal
                      visible={this.state.newClientModal}
                      onCancel={this.closeNewClientModal}
                      onCreated={this.handleClientCreated}
                    />
                  </>
                )}
              </div>
            </Spin>
          </Can>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.user.infos.id,
  };
};

export default connect(mapStateToProps, null)(SubmissionPage);

// WARNING: need a "join_to_invite" (TEXT) + "ammount" (int) in DB
const FIELDS = [
  {
    type: "text",
    key: "num",
    label: "No de soumission",
    block: "first",
    props: { disabled: true },
  },
  {
    type: "text",
    key: "title",
    label: "Titre",
    required: true,
    block: "first",
  },
  {
    type: "date",
    key: "date_visite",
    label: "Date de visite",
    block: "side",
    props: { showTime: true },
  },
  {
    type: "date",
    key: "date_depot",
    label: "Date de dépôt",
    block: "side",
    props: { showTime: true },
  },
  {
    type: "number",
    key: "ammount",
    label: "Montant déposé",
    block: "side",
  },
  {
    type: "checkbox",
    key: "caution",
    label: "Caution / Assurance",
    block: "side",
  },
  {
    type: "select",
    key: "submission_state_id",
    label: "État",
    required: true,
    options: {
      model: "SubmissionState",
      label: (s) => s.label,
    },
  },
  {
    type: "select",
    key: "project_type_id",
    label: "Type de projet",
    required: true,
    options: {
      model: "ProjectType",
      label: (t) => t.label,
    },
  },
  {
    type: "select",
    key: "client_id",
    label: "Client",
    required: true,
    options: {
      model: "Client",
      label: (c) => c.name,
    },
  },
  {
    type: "select",
    key: "region_id",
    label: "Région des travaux",
    required: true,
    options: {
      model: "Region",
      label: (r) => r.label,
    },
  },
  {
    type: "select",
    key: "user_id",
    label: "Estimateur",
    required: true,
    options: {
      model: "User",
      restrictTo: (u) => u.type_id === USER_RANK_ADMIN,
      label: (u) => `${u.name} ${u.surname}`,
    },
  },
  {
    type: "text",
    key: "client_manager",
    label: "Responsable client",
  },
  {
    type: "textarea",
    key: "join_to_invite",
    label: "Texte à joindre à l'invitation",
    block: "supplement",
  },
  {
    type: "textarea",
    key: "note",
    label: "Notes",
    block: "supplement",
  },
];
